import { createApi } from '@reduxjs/toolkit/query/react';
import { createAppBaseQuery } from '../../services/baseQuery';

export const notificationsApi = createApi({
  reducerPath: 'notificationsApi',
  baseQuery: createAppBaseQuery(),
  tagTypes: ['Notifications', 'Unread'],
  endpoints: (builder) => ({
    listNotifications: builder.query({
      query: (params) => ({ url: '/notifications', params }),
      providesTags: ['Notifications'],
    }),
    getUnreadCount: builder.query({
      query: () => '/notifications/unread-count',
      providesTags: ['Unread'],
    }),
    markRead: builder.mutation({
      query: (publicId) => ({ url: `/notifications/${publicId}/read`, method: 'PATCH' }),
      invalidatesTags: ['Notifications', 'Unread'],
    }),
    markAllRead: builder.mutation({
      query: () => ({ url: '/notifications/read-all', method: 'POST' }),
      invalidatesTags: ['Notifications', 'Unread'],
    }),
    getPreferences: builder.query({
      query: () => '/notification-preferences',
      providesTags: ['Notifications'],
    }),
    updatePreferences: builder.mutation({
      query: (body) => ({ url: '/notification-preferences', method: 'PATCH', body }),
      invalidatesTags: ['Notifications'],
    }),
  }),
});

export const {
  useListNotificationsQuery,
  useGetUnreadCountQuery,
  useMarkReadMutation,
  useMarkAllReadMutation,
  useGetPreferencesQuery,
  useUpdatePreferencesMutation,
} = notificationsApi;
